import { Hash } from '@phosphor-icons/react';

export default Hash;
